'use client'
import { Checkbox } from '@/components/Checkbox'
import { observer } from 'mobx-react-lite'
import { FC, PropsWithChildren } from 'react'
import styles from './AcceptCheckbox.module.scss'

interface AcceptCheckboxProps {
  className?: string
  value: boolean
  name: string
  error?: string
  onChange?: (value: boolean, name: string) => void
}
export const AcceptCheckbox: FC<AcceptCheckboxProps> = observer(
  ({ className, value, error, name, onChange }) => {
    return (
      <Checkbox
        name={name}
        error={error}
        testId="registrationAcceptPolicy"
        value={value}
        onChange={onChange}
        className={className}
      >
        <span className={styles.policyText}>
          Я принимаю{' '}
          <Link href="/documents/policy">
            условия политики обработки персональных данных
          </Link>{' '}
          и{' '}
          <Link href="/documents/user-agreement">
            пользовательского соглашения
          </Link>
          , а также даю{' '}
          <Link href="/documents/processing-personal-data">
            согласие на обработку персональных данных
          </Link>{' '}
          и{' '}
          <Link href="/documents/agreement-advertising-information-materials">
            согласие на информационные рассылки
          </Link>
        </span>
      </Checkbox>
    )
  }
)

interface LinkProps {
  href?: string
}
const Link: FC<PropsWithChildren<LinkProps>> = ({ href, children }) => {
  if (href != null && href.length !== 0) {
    return (
      <a href={href} target="_blank" className={styles.link}>
        {children}
      </a>
    )
  }

  return <span className={styles.link}>{children}</span>
}
